<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('Products')"
      :active.sync="showModal"
      id="deduction-generic-popup"
    >
      <form>
        <div class="vx-row mb-6">
          <div
            class="vx-col md:w-1/4 w-full"
            @click="isChangeInput('ProductName')"
          >
            <label class="vs-select--label datepicker-lb">{{
              $t("ProductName")
            }}</label>
            <vs-input
              v-if="!onChangeInput"
              v-model="model.ProductNameDis"
              disabled
            />
            <treeselect
              v-else
              v-model="model.ProductName"
              name="ProductName"
              :multiple="false"
              placeholder=""
              :async="true"
              :load-options="loadOptionsProductName"
              :disabled="!onChangeInput"
              @select="onSelectedProductName"
            />
          </div>
          <div
            class="vx-col md:w-1/4 w-full"
            @click="isChangeInput('ItemCode')"
          >
            <label class="vs-select--label datepicker-lb">{{
              $t("ItemCode")
            }}</label>
            <vs-input
              v-if="onChangeInput"
              v-model="model.ItemCodeDis"
              disabled
            />
            <treeselect
              v-else
              v-model="model.ItemCode"
              name="ItemCode"
              :multiple="false"
              placeholder=""
              :async="true"
              :load-options="loadOptionsItemCode"
              :disabled="onChangeInput"
              @select="onSelectedItemCode"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              class="mt-4"
              icon="icon-plus"
              @click.prevent="addSpecificProductToList()"
              >{{ $t("AddToList") }}</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-1">
            <div class="vx-col w-full">
              <vs-button
                @click="uploadFile()"
                class="bg_m_green float-right mt-4"
                v-if="fileUploaded"
                :disabled="disabledBtn"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload mt-4 float-right">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />
                <feather-icon
                  icon="PaperclipIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("AddSpecificProductsListViaExcel") }}
                <span v-if="uploadedFileName" class="file-name">{{
                  uploadedFileName
                }}</span>
              </label>
            </div>
          </div>
        </div>
      </form>
      <vs-table :data="listSpecificProduct" ref="table" class="custom-tbl">
        <template slot="thead">
          <th class="">#</th>
          <th>{{ $t("SpecificProductName") }}</th>
          <th>{{ $t("Action") }}</th>
        </template>

        <template>
          <vs-tr :key="i" v-for="(SpecificProduct, i) in listSpecificProduct">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ SpecificProduct.specificProductName }}
            </vs-td>
            <vs-td>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="unassignSpecificProduct(i)"
                class="d-inline"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="vx-col lg:w-1/5 w-full">
        <vs-button
          style="position: fixed; bottom: 3%; left: 3%"
          color="primary"
          type="filled"
          icon-pack="feather"
          class="float-right px-12 py-6"
          @click.prevent="assignSpecificProduct()"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#deduction-generic-popup .vs-popup--content {
  height: 100%;
}
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "saleManagement_Contract_Management_SpecificProductPopup",

  props: {
    show: { default: false },
    specificProductModel: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      dataCurrent: {},
      onChangeInput: true,
      model: {
        ProductName: null,
        ProductNameDis: null,
        ItemCode: null,
        ItemCodeDis: null,
      },
      listSpecificProduct: [],
      specificProductInfo: {
        id: null,
        specificProductsId: [],
      },
      specificProductId: null,
      searchQueryNew: "",
      searchQueryOld: "",
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      fetchSpecificProducts: "specificProduct/fetchFullSearch",
      getListSpecificProduct: "specificProduct/listSpecificProductPerContract",
      assignSpecificProductInfo: "specificProduct/assignItemInfo",
      importExcelSpecificProduct: "excel/importExcelSpecificProduct",
    }),
    isChangeInput(chosen) {
      if (chosen == "ProductName") {
        this.onChangeInput = true;
      } else {
        this.onChangeInput = false;
      }
    },
    loadOptionsProductName({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            var justProductName = "Name=" + searchQuery;
            this.fetchSpecificProducts(justProductName).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                  itemCode: element.itemCode,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onSelectedProductName(data) {
      this.dataCurrent = {};
      this.dataCurrent = data;
      this.model.ItemCodeDis = data.itemCode;
    },
    loadOptionsItemCode({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            var justItemCode = "ItemCode=" + searchQuery;
            this.fetchSpecificProducts(justItemCode).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.itemCode,
                  productName: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onSelectedItemCode(data) {
      this.dataCurrent = {};
      this.dataCurrent = data;
      this.model.ProductNameDis = data.productName;
    },
    addSpecificProductToList() {
      this.listSpecificProduct.push({
        specificProductId: this.dataCurrent.id,
        specificProductName: this.dataCurrent.label,
        itemCode: this.dataCurrent.itemCode,
      });
    },
    assignSpecificProduct() {
      var listSpecificId = [];
      this.specificProductInfo.id =
        this.specificProductModel.deductionAndIncreaseId;
      this.listSpecificProduct.forEach(function (element) {
        listSpecificId.push(element.specificProductId);
      });
      this.specificProductInfo.specificProductsId = listSpecificId;
      this.assignSpecificProductInfo(this.specificProductInfo).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "دسته مورد نظر با موفقیت اضافه شد!",
          color: "success",
        });
      });
    },
    unassignSpecificProduct(index) {
      this.listSpecificProduct.splice(index, 1);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importExcelSpecificProduct(formData).then(() => {});
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
      }, 1000);
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.getListSpecificProduct(
          this.specificProductModel.deductionAndIncreaseId
        ).then((r) => {
          this.listSpecificProduct = r.data;
        });
      }
    },
  },
  components: {
    "v-select": vSelect,
    Treeselect,
  },
};
</script>
